angular
    .module("bfConstants", [])
    .config([
        "$provide",
        "$httpProvider",
        function ($provide, $httpProvider) {
            $provide.factory("bfConstants", [
                "$templateCache",
                "$rootScope",
                "AuthInfo",
                function ($templateCache, $rootScope, AuthInfo) {
                    return {
                        request: function (config) {}
                    };
                }
            ]);
        }
    ])
    .run([
        "$rootScope",
        function ($rootScope) {
            // Permission constants
            $rootScope.PERMISSION_ROLE_NONE = 0;
            $rootScope.PERMISSION_ROLE_USER = 1;
            $rootScope.PERMISSION_ROLE_ADMIN = 2;
            $rootScope.PERMISSION_ROLE_OWNER = 3;
            $rootScope.PERMISSION_ROLE_EXTERNAL_USER = 5;
            $rootScope.PERMISSION_ROLE_TEXT_EDITOR = 6;
            $rootScope.PERMISSION_ROLE_DESIGNER = 7;
            $rootScope.PERMISSION_ROLE_TEXT_EDITOR_EXTENDED = 8;
            $rootScope.PERMISSION_ROLE_EXTERNAL_DESIGNER = 9;
            $rootScope.PERMISSION_ROLE_PUBLISHER = 10;
            $rootScope.PERMISSION_ROLE_ANALYZER = 11;
            $rootScope.PERMISSION_ROLE_TEXT_EDITOR_WITH_ANALYZER = 12;
            $rootScope.PERMISSION_ROLE_PUBLISHER_EXTENDED = 13;

            // ####       ####      ####       ####      ####       ####      ####       ####
            //          Features list, an exact copy should exist in Permissions.cs
            // ####       ####      ####       ####      ####       ####      ####       ####
            $rootScope.FEATURE_ANY = "Any";

            //	STANDARD
            $rootScope.FEATURE_EDITOR = "Editor";
            $rootScope.FEATURE_CREATOR = "Creator";
            $rootScope.FEATURE_TEXTEDITOR = "TextEditor";
            $rootScope.FEATURE_PUBLISHER = "Publisher";
            $rootScope.FEATURE_ANALYSER = "Analyzer";
            $rootScope.FEATURE_SETTINGS = "Settings";
            $rootScope.FEATURE_SHARE = "Share";
            $rootScope.FEATURE_BANNERSETDUPLICATE = "BannerSetDuplicate";

            //	SPECIALS
            $rootScope.FEATURE_FEEDS = "Feeds";
            $rootScope.FEATURE_FEEDSLIVE = "FeedsLive";
            $rootScope.FEATURE_FEEDSAUTOMATED = "FeedsAutomated";

            $rootScope.FEATURE_HASFEEDS = new Array(
                $rootScope.FEATURE_FEEDS,
                $rootScope.FEATURE_FEEDSLIVE,
                $rootScope.FEATURE_FEEDSAUTOMATED
            );

            $rootScope.FEATURE_COMMENTS = "Comments";
            $rootScope.FEATURE_APPROVE = "Approve";
            $rootScope.FEATURE_BANNERSETDONEMARK = "BannersetDoneMark";
            $rootScope.FEATURE_BARRECURLY = "BarRecurly";
            $rootScope.FEATURE_BARRECURLYV2 = "BarRecurlyV2";
            $rootScope.FEATURE_BARBANDWIDTH = "BarBandwidth";
            $rootScope.FEATURE_BARIMPRESSIONS = "BarImpressions";
            $rootScope.FEATURE_DIRECTPUBLISHING = "DirectPublishing";
            $rootScope.FEATURE_INVOICERECURLY = "InvoiceRecurly";
            $rootScope.FEATURE_INVOICEAGENCY = "InvoiceAgency";
            $rootScope.FEATURE_INVOICEENTERPRISE = "InvoiceEnterprise";
            $rootScope.FEATURE_INTRIAL = "InTrial";
            $rootScope.FEATURE_CUSTOMASSETS = "CustomAssets";
            $rootScope.FEATURE_CUSTOMCSS = "CustomCss";
            $rootScope.FEATURE_CUSTOMEMBEDCODES = "CustomEmbedCodes";
            $rootScope.FEATURE_MULTIPLEBRANDS = "MultipleBrands";
            $rootScope.FEATURE_MULTIPLEUSERS = "MultipleUsers";
            $rootScope.FEATURE_NOHEADER = "NoHeader";
            $rootScope.FEATURE_NOBRANDING = "NoBranding";
            $rootScope.FEATURE_PAYPERFALLBACKDOWNLOAD = "PayPerFallbackDownload";
            $rootScope.FEATURE_CPMIMPRESSIONS = "CpmImpressions";
            $rootScope.FEATURE_LABELS = "Labels";
            $rootScope.FEATURE_REQUIREPASSWORDFORNEWBRANDS = "RequirePasswordForNewBrands";
            $rootScope.FEATURE_ADVANCEDFORMATS = "AdvancedFormats";
            $rootScope.FEATURE_DELETECOMMENTS = "DeleteComments";
            $rootScope.FEATURE_LOCK = "Lock";
            $rootScope.FEATURE_STORE = "Store";
            $rootScope.FEATURE_LANDINGPAGE = "LandingPage";
            $rootScope.FEATURE_ANALYTICS = "Analytics";
            $rootScope.FEATURE_TRACKINGPIXELS = "TrackingPixels";
            $rootScope.FEATURE_EXTERNALTRANSLATIONS = "ExternalTranslations";
            $rootScope.FEATURE_MESSAGESYSTEM = "MessageSystem";
            $rootScope.FEATURE_SCHEDULING = "Scheduling";
            $rootScope.FEATURE_ANALYTICS_DEMO_DATA = "AnalyticsDemoData";
            $rootScope.FEATURE_TWO_FACTOR_AUTHENTICATION = "TwoFactorAuthentication";
            $rootScope.FEATURE_VIDEOCONVERTER = "VideoConverter";
            $rootScope.FEATURE_UPSELLVIEWS = "UpsellViews";

            // EDITOR
            $rootScope.FEATURE_EDITORKEYFRAMES = "EditorKeyFrames";
            $rootScope.FEATURE_STUDIO = "Studio";
            $rootScope.FEATURE_CAMPAIGNMANAGER = "CampaignManager";
            $rootScope.FEATURE_SOCIALCAMPAIGNMANAGER = "SocialCampaignManager";
            $rootScope.FEATURE_SOCIALDYNAMICADVERTISING = "SocialDynamicAdvertising";

            // Themes
            $rootScope.FEATURE_THEMEENTERPRISE = "ThemeEnterprise";

            $rootScope.EMAILPREFERENCE_CPMPAYMENT = "emailPreferenceCPMPayment";

            // MESSAGE TYPE
            $rootScope.MESSAGE_TYPE_NONE = 0;
            $rootScope.MESSAGE_TYPE_MAINTENANCE = 1;
            $rootScope.MESSAGE_TYPE_PROMOTION = 2;
            $rootScope.MESSAGE_TYPE_SERVICEINTERUPTION = 3;
            $rootScope.MESSAGE_TYPE_TIPS = 4;
            $rootScope.MESSAGE_TYPE_URGENT = 5;

            $rootScope.OBJECT_TYPE_FOLDER = 2147483647;
            $rootScope.OBJECT_TYPE_FEED = 1;
            $rootScope.OBJECT_TYPE_LANDINGPAGE = 3;
            $rootScope.OBJECT_TYPE_CREATIVESET = 4;

            $rootScope.OBJECT_STATE_ACTIVE = 0;
            $rootScope.OBJECT_STATE_DELETED = 1;
            $rootScope.OBJECT_STATE_ARCHIVED = 2;

            $rootScope.LANDINGPAGE_STATUS_UNKNOWN = 0;
            $rootScope.LANDINGPAGE_STATUS_UNPUBLISHED = 1;
            $rootScope.LANDINGPAGE_STATUS_PUBLISHED = 2;
            $rootScope.LANDINGPAGE_STATUS_PARTIALLYPUBLISHED = 3;

            $rootScope.FEED_SOURCE_TYPE_UNKNOWN = 0;
            $rootScope.FEED_SOURCE_TYPE_MANUAL = 1;
        }
    ]);
